import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
import moment from 'moment/min/moment-with-locales';

import { LOCALES_ROOT, SERVER_IS_NORWAY } from '~/library/config';

const defaultLocale = window.sessionStorage.getItem('locale') || (SERVER_IS_NORWAY ? 'no' : 'en');

moment.locale(defaultLocale === 'no' ? 'nb' : 'en');

i18n.use(XHR)
    .init({
        backend: {
            loadPath: `${LOCALES_ROOT}/{{lng}}/{{ns}}.json`,
        },
        fallbackLng: defaultLocale,
        load: 'languageOnly',
        debug: false,
        keySeparator: '....',
        nsSeparator: '::::',
    });
export default i18n;
